import {ChangeDetectorRef, Injectable, Pipe, ElementRef} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Injectable()
@Pipe({
  name: 'pershingTranslate',
  pure: false // required to update the value when the promise is resolved
})
export class PershingTranslatePipe extends TranslatePipe {
    constructor(private translateService: TranslateService, private _changeRef: ChangeDetectorRef, private elRef: ElementRef) {
        super(translateService, _changeRef);
    }
    transform(query: string, id: string = '', ...args: any[]): any {
        if (!query || query.length === 0) {
            return query;
        }
        let idQuery = query;
        if (id && id !== '') {
            idQuery = `${id}.${query}`;
        } else {
            if (this.elRef) {
                let domId = this.retrieveId(this.elRef.nativeElement);
                if (domId && domId !== '') {
                    idQuery = `${domId}.${query}`;
                }
            }
        }
        if (this.translateService.instant(idQuery, args) && this.translateService.instant(idQuery, args) !== idQuery) {
            return super.transform(idQuery, args);
        } else {
            return super.transform(query, args);
        }
    }

    private retrieveId(element: HTMLElement): string {
        if (element && element.tagName !== 'body') {
            if (element.classList.length > 0 && element.classList.contains('finder')) {
                return element.getAttribute('id');
            } else {
                return this.retrieveId(element.parentElement);
            }
        }
        return '';
    }
}
